import { NgModule } from '@angular/core';
import { UppercaseInputDirective } from './uppercase-input.directive';
import { NumericOnlyInputDirective } from './numeric-only-input.directive';
import { CurrencyInputDirective } from './currency-input.directive';

@NgModule({
  imports: [UppercaseInputDirective, NumericOnlyInputDirective, CurrencyInputDirective],
  exports: [UppercaseInputDirective, NumericOnlyInputDirective, CurrencyInputDirective],
})
export class LosInputDirectivesModule {}
